import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {DialogCustomPage} from './dialog-custom';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    DialogCustomPage,
  ],
  imports: [
    IonicPageModule.forChild(DialogCustomPage),
    TranslateModule.forChild()
  ],
})
export class DialogCustomPageModule {}



// WEBPACK FOOTER //
// ./src/pages/dialog-custom/dialog-custom.module.ts